export const dashboard = {
  dashboard: "Dashboard",
  apply: "APPLY",
  incomeSummary: "Income Summary",
  totalDeposit: "Total Deposit",
  estimateProfit: "Estimate Profit",
  Transactions: "Transactions",
  thb: "THB",
  totalPlayerBonus: "Total Player Bonus",
  calimedCommissions: "Calimed Commissions",
  calimedAffiliate: "Calimed Affiliate",
  gameplayStatistics: "Game Play Statistics",
  estimatedBet: "Estimated Bet",
  estimatePlayerWin: "Estimate Player Win",
  estimatedWinLoss: "Estimate Win/Loss",
  playerStatistic: "Player Statistic",
  newUsers: "New Users",
  averageActiveUsersPerHour: "Average Active Users Per Hour",
  gameRounds: "Game Rounds",
  users: "Users",
  rounds: "Rounds",
  mostProfitableGame: "Most Profitable Game",
  mostPopularGame: "Most Popular Game",
  game: "Game",
  rank: "Rank",
  averageActivePlayers: "Average Active Players",
  totalWithdraw: "Total Withdraw",
  gameRounds: "Game Rounds",
};
